module.exports = __webpack_public_path__ + "static/media/javascripts.afeca4d9.svg";